import { useState, useEffect } from "react";
import { Form, InputNumber } from "antd";
import { useTranslation } from "react-i18next";
import CustomModal from "../../../components/Common/CustomModal";
interface EditFeeAmountModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (amount: number) => Promise<boolean>;
  currentAmount: number;
}

const EditFeeAmountModal: React.FC<EditFeeAmountModalProps> = ({
  isOpen,
  onClose,
  onSave,
  currentAmount,
}) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      form.setFieldsValue({ amount: currentAmount });
    }
  }, [isOpen, currentAmount]);

  const handleSave = async () => {
    try {
      setLoading(true);
      const values = await form.validateFields();
      const res = await onSave(Number(values.amount));
      if (res) {
        onClose();
        form.resetFields();
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <CustomModal
      title={t("update_fee_amount")}
      isOpen={isOpen}
      onClose={onClose}
      onSave={handleSave}
      loading={loading}
      saveText={t("save")}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label={t("amount")}
          name="amount"
          rules={[{ required: true, message: t("validation.please_enter_amount") }]}
        >
          <InputNumber
            className="w-100"
            min={0}
            precision={2}
            addonAfter="MAD"
            formatter={(value) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
          />
        </Form.Item>
      </Form>
    </CustomModal>
  );
};

export default EditFeeAmountModal;
